<template>
  <div>
    <el-dialog
      title="比赛录入"
      :visible.sync="value"
      width="40%"
      :before-close="pkInDialogCloses"
      :close-on-click-modal="false"
    >
      <div class="flex">
        <span>请选择比赛：</span>
        <el-select
          v-model="gameId"
          placeholder="请选择比赛"
          size="mini"
          @change="PKInValueChange"
        >
          <el-option
            v-for="item in PKInOptions"
            :key="item.id"
            :label="item.gameName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <div class="upallPhoto">
          <el-upload
            class="buttonUp"
            accept=".png,.jpg,.jpeg,.JPG,.JPEG"
            :headers="headers"
            :action="upLoadUrl"
            :show-file-list="false"
            :on-success="upAllPhotoPathSuccess"
          >
            <span v-if="!photoPath">上传照片</span>
            <span v-if="photoPath">重新上传</span>
          </el-upload>
          <div v-if="photoPath" class="uped">
            <el-popover placement="right" width="400" trigger="click">
              <img :src="globelurls + photoPath" alt="" class="upphoto" />
              <el-button class="minibutton" slot="reference" type="primary"
                >查看</el-button
              >
            </el-popover>
          </div>
        </div>
      </div>
      <div v-if="show" style="margin-top: 10px; color: red">
        <span>赛事详情：</span>
        <br />
        <span style="margin-left: 15px">弓种:{{ bowTypeName }}</span>
        <span style="margin-left: 15px">米数:{{ pkDetails.meterType }}米</span>
        <span style="margin-left: 15px"
          >组数:{{ pkDetails.groupCountType }}组</span
        >
        <span style="margin-left: 15px"
          >每组箭支:{{ pkDetails.groupArrow }}支</span
        >
        <span style="margin-left: 15px">靶纸:{{ targetSheetText }}</span>
        <br />
        <span style="margin-left: 15px"
          >开始日期:{{ pkDetails.gameDateStart }}</span
        >
        <span style="margin-left: 15px"
          >结束日期:{{ pkDetails.gameDateEnd }}</span
        >
      </div>
      <div v-if="show">
        <div
          v-for="(item, groupIndex) in groupCountType"
          :key="groupIndex"
          class="PKInBox"
        >
          <div class="leftTitle">第{{ item }}组:</div>
          <div class="rightMain">
            <el-input
              v-for="(val, arrowIndex) in groupArrow"
              :key="arrowIndex"
              class="PKInval"
              size="mini"
              v-model="gameScoreList[groupIndex].score[arrowIndex]"
              maxlength="2"
              @input="inputPkNum($event, groupIndex, arrowIndex)"
              :ref="groupIndex"
            ></el-input>
            <el-upload
              class="buttonUp"
              accept=".png,.jpg,.jpeg,.JPG,.JPEG"
              :headers="headers"
              :action="upLoadUrl"
              :show-file-list="false"
              :on-success="
                creatHandleAvatarSuccess.bind(null, {
                  index: groupIndex,
                  data: item,
                })
              "
            >
              <span v-if="!gameScoreList[groupIndex].gamePhoto">上传照片</span>
              <span v-if="gameScoreList[groupIndex].gamePhoto">重新上传</span>
            </el-upload>
          </div>
          <div v-if="gameScoreList[groupIndex].gamePhoto" class="uped">
            <el-popover placement="right" width="400" trigger="click">
              <img
                :src="globelurls + gameScoreList[groupIndex].gamePhoto"
                alt=""
                class="upphoto"
              />
              <el-button class="minibutton" slot="reference" type="primary"
                >查看</el-button
              >
            </el-popover>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pkInDialogTrue">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAntGameList,
  typeInMemberGameScore,
  getGameScoreListByOrder,
} from "@/api/OrderManagement.js";
import { bowTypes, targetSheet } from "../../api/OperationManagement";
import { posturl, globelurl } from "../../api/axios.js";
export default {
  name: "pkIn",
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue) {
          getGameScoreListByOrder({
            memberId: this.memberId,
            orderId: this.orderId,
          }).then((res) => {
            // console.log(res);
            if (res.status === 200 && res.data.success) {
              if (res.data.result.length >= 1) {
                this.show = true;
                this.gameScoreList = [];
                this.gameId = res.data.result[0].gameId;
                this.photoPath = res.data.result[0].photoPath;
                res.data.result.forEach((item) => {
                  item.score = item.score.split(",");
                  this.groupArrow = item.score.length;
                });
                this.gameScoreList = res.data.result;
                this.groupCountType = res.data.result.length;
                this.getPkDetail(this.gameId);
              }
            }
          });
        }
      },
    },
  },
  props: {
    value: {
      type: Boolean,
    },
    memberId: {
      type: String,
    },
    orderId: {
      type: String,
    },
  },
  data() {
    return {
      headers: { "X-Access-Token": sessionStorage.token },
      upLoadUrl: posturl,
      gameId: "",
      PKInOptions: [],
      groupCountType: "", //几组
      groupArrow: "", //每组几只
      gameScoreList: [],
      show: false,
      globelurls: globelurl,
      pkDetails: {},
      bowTypeName: "",
      photoPath: "",
      bowTypeList: [],
      targetSheetList: [],
      targetSheetText: "",
    };
  },
  mounted() {
    this.getAntGameList();
    this.bowTypes();
    this.targetSheet();
  },
  methods: {
    // 比赛下拉
    getAntGameList() {
      getAntGameList().then((res) => {
        if (res.data.success) {
          this.PKInOptions = res.data.result;
        }
      });
    },
    // 获取弓种字典
    bowTypes() {
      bowTypes().then((res) => {
        if (res.data.success) {
          this.bowTypeList = res.data.result;
        }
      });
    },
    // 获取靶纸字典
    targetSheet() {
      targetSheet().then((res) => {
        if (res.data.success) {
          this.targetSheetList = res.data.result;
        }
      });
    },
    // 获取赛事详情
    getPkDetail(id) {
      this.PKInOptions.forEach((item) => {
        if (item.id == id) {
          this.pkDetails = item;
        }
      });
      // 弓种字典
      (this.bowTypeName = this.bowTypeList.find(
        (item) => item.value === this.pkDetails.bowType
      ).text),
        //  靶值字典
        (this.targetSheetText = this.targetSheetList.find(
          (item) => item.value === this.pkDetails.targetSheet
        ).text);
    },
    // 比赛下拉事件
    PKInValueChange(val) {
      this.show = true;
      this.PKInOptions.forEach((item) => {
        if (item.id == val) {
          this.pkDetails = item;
          this.groupCountType = item.groupCountType * 1;
          this.groupArrow = item.groupArrow * 1;
        }
      });
      // 弓种字典
      (this.bowTypeName = this.bowTypeList.find(
        (item) => item.value === this.pkDetails.bowType
      ).text),
        //  靶值字典
        (this.targetSheetText = this.targetSheetList.find(
          (item) => item.value === this.pkDetails.targetSheet
        ).text),
        // this.groupCountType  几组
        // this.groupArrow  每组几只
        (this.gameScoreList = []);
      for (let i = 0; i < this.groupCountType; i++) {
        this.gameScoreList.push({ gamePhoto: "", score: [] });
        for (let j = 0; j < this.groupArrow; j++) {
          this.gameScoreList[i].score.push("");
        }
      }
    },
    pkInDialogTrue() {
      if (this.gameId == "") {
        this.$message({
          message: "请选择比赛",
          type: "warning",
        });
      } else {
        let reg = /^([1-9]|10)$|[x]|[m]/;
        let flag = true;
        for (let i = 0; i < this.gameScoreList.length; i++) {
          if (flag) {
            for (let j = 0; j < this.gameScoreList[i].score.length; j++) {
              if (this.gameScoreList[i].score[j] == "") {
                flag = false;
                this.$message({
                  message: "请完善比赛成绩",
                  type: "warning",
                });
                break;
              }
              if (!reg.test(this.gameScoreList[i].score[j])) {
                flag = false;
                this.$message({
                  message:
                    "请正确填写比赛成绩(x,m环数为小写字母,且比赛成绩为1-10环) ",
                  type: "warning",
                });
                break;
              }
            }
          }
        }
        if (flag) {
          let params = JSON.parse(JSON.stringify(this.gameScoreList));
          params.forEach((it, index) => {
            it.gameId = this.gameId;
            it.orderId = this.orderId;
            it.memberId = this.memberId;
            it.groupIndex = index;
            it.score = it.score.toString();
          });

          typeInMemberGameScore({
            photoPath: this.photoPath,
            gameScoreList: params,
          }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.$message({
                message:
                  "操作成功" +
                  "," +
                  "操作人" +
                  ":" +
                  sessionStorage.realName +
                  "," +
                  "本次操作已被记录存档",
                type: "success",
              });
              this.pkInDialogCloses();
            }
          });
        }
      }
    },
    pkInDialogCloses() {
      this.$emit("pkInDialogClose", false);
      this.gameId = "";
      this.show = false;
      this.photoPath = "";
    },
    // 全局照片
    upAllPhotoPathSuccess(res, file) {
      this.photoPath = res.result.pathList[0];
    },
    // 照片上传
    creatHandleAvatarSuccess(obj, res, file) {
      if (res.success) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        const index = obj.index;
        this.gameScoreList[index].gamePhoto = res.result.pathList[0];
        // console.log(this.gameScoreList);
      } else {
        this.$message.error(res.message);
      }
    },
    inputPkNum(val, i, ind) {
      // console.log(val, "输入框的值");
      // console.log(i, "外层循环下标，第几组");
      // console.log(ind, "内层循环下标，第几支");
      let reg = /^([1-9]|10)$|[x]|[m]/;
      if (!reg.test(val)) {
        // 没通过校验
        if (val != "") {
          this.$message({
            message:
              "请正确填写比赛成绩(x,m环数为小写字母,且比赛成绩为1-10环) ",
            type: "warning",
          });
          this.gameScoreList[i].score[ind] = "";
          return;
        }
      }
      // groupCountType: "", //几组
      // groupArrow: "", //每组几只
      // console.log(val);
      // // 1不跳
      if (val >= 2 && val <= 10|| val=="x"||val=="m") {
        if (ind * 1 + 1 < this.groupArrow) {
          let d = ind + 1;
          this.$nextTick(() => {
            this.$refs[i][d].focus();
          });
        }
        if (ind * 1 + 1 == this.groupArrow) {
          let n = i + 1;
          this.$nextTick(() => {
            this.$refs[n][0].focus();
          });
          if (n == this.groupCountType) {
            // console.log("圆满结束");
            return;
          }
        }
      }
      // 1延迟跳
      // if (val == 1) {
      //   setTimeout(() => {
      //     if (ind * 1 + 1 < this.groupArrow) {
      //       let d = ind + 1;
      //       this.$nextTick(() => {
      //         this.$refs[i][d].focus();
      //       });
      //     }
      //   }, 500);
      // } else if (val >= 2 && val <= 10|| val=="x"||val=="m") {
      //   console.log(111);
      //   if (ind * 1 + 1 < this.groupArrow) {
      //     let d = ind + 1;
      //     this.$nextTick(() => {
      //       this.$refs[i][d].focus();
      //     });
      //   }
      // }
      // if (ind * 1 + 1 == this.groupArrow) {
      //   let n = i + 1;
      //   this.$nextTick(() => {
      //     this.$refs[n][0].focus();
      //   });
      //   if (n == this.groupCountType) {
      //     // console.log("圆满结束");
      //     return;
      //   }
      // }
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
}
.PKInBox {
  margin-top: 25px;
  display: flex;
}
.leftTitle {
  width: 65px;
  margin-top: 12px;
}
.rightMain {
  display: flex;
  flex-wrap: wrap;
}
.PKInval {
  width: 50px;
  margin-left: 20px;
  margin-top: 10px;
}
.buttonUp {
  position: relative;
  /* top: -7px; */
  left: 12px;
}
.upphoto {
  width: 350px;
  height: 350px;
}
.uped {
  margin-top: 12px;
  margin-left: 25px;
}
.minibutton {
  background: rgb(64, 158, 255);
  width: 80px;
  height: 18px;
  line-height: 0px;
  text-align: center;
}
.upallPhoto {
  position: relative;
  /* top: -9px; */
  display: flex;
}
</style>



